export const EXCLUSIVE_GAME_LABEL = {
    background: '#fae311',
    textColor: '#97261f',
    text: 'EKSKLUSIVT',
}
